webpackJsonp([20],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/news.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _nav = __webpack_require__("./src/components/nav/nav.js");
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _footer = __webpack_require__("./src/components/footer/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../css/index.css'; // add some style if you want!
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { charSet: "utf-8" }),
	      _react2.default.createElement(
	        "title",
	        null,
	        "News | DSA Momentum"
	      )
	    ),
	    _react2.default.createElement(_nav2.default, null),
	    _react2.default.createElement(
	      "div",
	      { className: "main__row" },
	      _react2.default.createElement(
	        "h3",
	        { className: "main__page-title" },
	        "News"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "main__body-copy" },
	        posts.filter(function (post) {
	          return post.node.frontmatter.title.length > 0;
	        }).map(function (_ref2) {
	          var post = _ref2.node;
	
	          return _react2.default.createElement(
	            "div",
	            { className: "main__post-section", key: post.id },
	            _react2.default.createElement(
	              "h4",
	              { className: "main__links-section-title" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.frontmatter.path },
	                post.frontmatter.title
	              )
	            ),
	            _react2.default.createElement(
	              "small",
	              null,
	              post.frontmatter.date
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              post.excerpt
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-news-js-466d604ad9a5c4c0f652.js